import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Button } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  border: none;
  padding: 4px;
  background: #fff;
`;

export const Title = styled.div`
  font-size: 14px;
  margin-bottom: 16px;
  text-align: right;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.light};
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media screen and (max-width: 768px) {
    justify-content: space-between;
  }
`;

export const AttachmentButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  width: 185px;
  max-width: 185px;
  height: 40px;
  border: 1px solid #dfe2e6;
  border-radius: 10px;
  font-size: 12px;
  font-weight: ${FONT_WEIGHT.regular};
  color: #1a295a;
  padding: 7px 12px;
  span:not(.anticon) {
    font-size: 12px;
    font-weight: ${FONT_WEIGHT.regular};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  span.anticon {
    font-size: 18px;
    color: #1a295a;
    margin-block: auto;
  }

  &:hover {
    color: #1a295a;
    border-color: #1a295a;
  }

  svg {
    width: 1em;
    height: 1em;
  }

  svg.lucide-trash {
    width: 2rem;
    height: auto;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 160px;
  }
`;
